export const MENU_STATE_KEY = "npt-menu-state";

export const SEND_MENU_MINIMISED = 'SEND_MENU_MINIMISED';
export type SEND_MENU_MINIMISED = typeof SEND_MENU_MINIMISED;

export const SEND_MENU_CLOSED = 'SEND_MENU_CLOSED';
export type SEND_MENU_CLOSED = typeof SEND_MENU_CLOSED;

export const SEND_MENU_ACTIVE = 'SEND_MENU_ACTIVE';
export type SEND_MENU_ACTIVE = typeof SEND_MENU_ACTIVE;